import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MyWalletRoutingModule} from './my-wallet-routing.module';
import {MyWalletComponent} from './my-wallet.component';
import {CoreSidebarModule} from '../../../@core/components';
import {ReactiveFormsModule} from '@angular/forms';
import {CoreDirectivesModule} from '../../../@core/directives/directives';
import {SharedModule} from '../../shared/shared.module';

@NgModule({
    declarations: [MyWalletComponent],
    imports: [
        CommonModule,
        MyWalletRoutingModule,
        CoreSidebarModule,
        SharedModule,
        ReactiveFormsModule,
        CoreDirectivesModule
    ]
})
export class MyWalletModule {
}
